import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getAudit, type AuditFilters } from '@/lib/api/audit'

/**
 * Audit Log query (Screen 8). Keyed on the full filter+pagination set;
 * keepPreviousData holds the current page visible while the next one loads so
 * paging doesn't flash empty.
 */
export function useAudit(filters: AuditFilters) {
  return useQuery({
    queryKey: [
      'audit',
      filters.start ?? '',
      filters.end ?? '',
      filters.event_type ?? '',
      filters.user ?? '',
      filters.order_number ?? '',
      filters.q ?? '',
      filters.limit ?? 50,
      filters.offset ?? 0,
    ],
    queryFn: () => getAudit(filters),
    staleTime: 15_000,
    placeholderData: keepPreviousData,
  })
}
